<template>
  <v-container>
    <div class="text-center">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
      <h3>Procesando pago...</h3>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'MercadoPagoRedirect',
  mounted () {
    // Este componente no debería renderizarse nunca
    // porque el beforeEnter debería redirigir inmediatamente
    console.warn('MercadoPagoRedirect component mounted - this should not happen')
  }
}
</script>
